document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("zoomModal");
  const modalImg = document.querySelector(".zoom-modal-img");
  const closeBtn = document.querySelector(".zoom-close");
  const nextBtn = document.querySelector(".zoom-next");
  const prevBtn = document.querySelector(".zoom-prev");

  const images = Array.from(document.querySelectorAll(".zoom-image"));
  const icons = document.querySelectorAll(".zoom-icon");

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  let currentIndex = 0;

  icons.forEach((icon) => {
    icon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      currentIndex = parseInt(icon.getAttribute("data-index"));
      modal.classList.add("show");
      modalImg.src = images[currentIndex].src;

      document.body.style.overflow = "hidden";
    });
  });

  function closeModal() {
    modal.classList.remove("show");
    document.body.style.overflow = "";
  }

  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeModal();
  });

  nextBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % images.length;
    modalImg.src = images[currentIndex].src;
  });

  prevBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    modalImg.src = images[currentIndex].src;
  });

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeModal();
    }
  });
});